function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.077 1.577h.975a.82.82 0 01.803.651L5.21 8.665a.82.82 0 00.869.648l6.73-.54a.82.82 0 00.755-.818V4.038a.82.82 0 00-.82-.82H4.29M6.179 10.064v.82c0 .454.367.82.82.82h5.743",
  stroke: "#183558",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.846,
  cy: 13.346,
  r: 1,
  fill: "#183558"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.709,
  cy: 13.346,
  r: 1,
  fill: "#183558"
});

var SvgPurchaseHeaderCart = function SvgPurchaseHeaderCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgPurchaseHeaderCart;